import ProductCard from '../components/svelte/ProductCard.svelte';
import Product from '../models/Product.js';

const renderProductCards = () => {
  [...document.querySelectorAll('[data-product-card][data-unloaded]')].forEach(
    card => {
      try {
        const productData = JSON.parse(card.dataset.productCard);
        const inventoryData = JSON.parse(card.dataset.variantInventoryData);

        productData.variants = productData.variants.map(variant => {
          return {
            ...variant,
            quantity: inventoryData[variant.id].inventory_quantity,
          };
        });

        // eslint-disable-next-line no-new
        new ProductCard({
          target: card,
          props: {
            product: Product.fromShopify(productData),
          },
        });

        card.removeAttribute('data-unloaded');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  );
};

export default renderProductCards;
